import { render, staticRenderFns } from "./SeriesList.vue?vue&type=template&id=bcd20ae2&scoped=true&"
import script from "./SeriesList.vue?vue&type=script&lang=js&"
export * from "./SeriesList.vue?vue&type=script&lang=js&"
import style0 from "./SeriesList.vue?vue&type=style&index=0&id=bcd20ae2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd20ae2",
  null
  
)

export default component.exports